import { Alert, Button, Tooltip } from "antd";
import { useEffect, useState } from "react";
import { unsentDietDatesApi } from "../../../../../../../config/Api";
import { DIET_STATUS_EVENT, sendDiet, shortDate } from "./dietStatus";

// "saved but not sent" warning, shown until those days are sent to the patient
export const UnsentDietBanner = ({ patientId }) => {
    const [dates, setDates] = useState([])
    const [canSend, setCanSend] = useState(false)
    const [sending, setSending] = useState(false)

    const load = () => {
        unsentDietDatesApi(patientId)
            .then((res) => {
                setDates(res.data.data)
                setCanSend(res.data.can_send)
            })
            .catch(() => {})
    }

    useEffect(() => {
        load()
        window.addEventListener(DIET_STATUS_EVENT, load)
        return () => window.removeEventListener(DIET_STATUS_EVENT, load)
    }, [patientId])

    if (!dates.length) return null

    const send = () => {
        setSending(true)
        sendDiet(patientId, dates).finally(() => setSending(false))
    }

    return (
        <Alert
            className="mb-3"
            type="warning"
            showIcon
            message={`The diet for ${dates.map(shortDate).join(', ')} is saved but not sent to the patient.`}
            description="The patient only gets a diet when it is sent (email with the full plan as a PDF)."
            action={
                <Tooltip title={canSend ? '' : "The patient hasn't verified their email yet."}>
                    <Button type="primary" loading={sending} disabled={!canSend} onClick={send}>Send now</Button>
                </Tooltip>
            }
        />
    )
}
